import React from 'react';
import { useSelector } from 'umi';
import { PC_PAGE_CONFIG } from './pcPageConfig';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import { NIGHTGALE_PAGE_CONFIG } from './nightgalePageConfig';
import { CASUAL_PAGE_CONFIG } from './casualPageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';

import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';

const reqParams = '/comparisonAnalysis/eventComparison';

interface pageConfigObjProp {
  [key:string]:IPageConfigType;
}
const pageConfigObj: pageConfigObjProp = {
  mobile: MOBILE_PAGE_CONFIG as unknown as IPageConfigType,
  pc: PC_PAGE_CONFIG as unknown as IPageConfigType,
  pc_inflexion: NIGHTGALE_PAGE_CONFIG as unknown as IPageConfigType,
  casual: CASUAL_PAGE_CONFIG as unknown as IPageConfigType,
};

const pcDateComparison = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  });
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageConfigObj?.[dataFrame]} />
    </>
  );
};

export default pcDateComparison;